import React, { forwardRef, useMemo } from 'react';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { ColDef, ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// Register AG-Grid modules once
ModuleRegistry.registerModules([AllCommunityModule]);

const BASE_DEFAULT_COL_DEF: ColDef = {
  sortable: true,
  filter: true,
  resizable: true,
};

export interface AgGridWrapperProps<TData = unknown> extends AgGridReactProps<TData> {
  containerClassName?: string;
}

function AgGridWrapperInner<TData = unknown>(
  { containerClassName, defaultColDef, ...gridProps }: AgGridWrapperProps<TData>,
  ref: React.Ref<AgGridReact<TData>>,
) {
  const mergedDefaultColDef = useMemo<ColDef>(
    () => ({ ...BASE_DEFAULT_COL_DEF, ...defaultColDef }),
    [defaultColDef],
  );

  return (
    <div className={containerClassName || 'ag-theme-alpine h-full w-full'}>
      <AgGridReact<TData>
        ref={ref}
        defaultColDef={mergedDefaultColDef}
        {...gridProps}
      />
    </div>
  );
}

const AgGridWrapper = forwardRef(AgGridWrapperInner) as <TData = unknown>(
  props: AgGridWrapperProps<TData> & { ref?: React.Ref<AgGridReact<TData>> },
) => React.ReactElement | null;

export default AgGridWrapper;
